module.exports = __webpack_public_path__ + "img/default-user-background.be57680d.svg";